import { type FC, type ReactNode } from "react";
import { Icon } from "@root/shared/components/Icon";
import { fontSize } from "@root/shared/styles/sprinkles.css";
import { type Rank } from "@userFrontend/features/promotion/types/type";
import * as styles from "./styles.css";

type Props = {
  children: ReactNode;
  className?: string;
} & RankingIconProps;

type RankingIconProps = {
  rank: Rank;
};

const RankingIcon: FC<RankingIconProps> = ({ rank }) => {
  switch (rank) {
    case "potential":
      return <Icon name="light" fontSize={fontSize["fs-12"]} />;
    case "bronze":
      return (
        <img
          src="/images/user_frontend/global/icon/icn_awards_bronze.svg"
          alt="ブロンズ"
          className={styles.medal}
        />
      );
    case "silver":
      return (
        <img
          src="/images/user_frontend/global/icon/icn_awards_silver.svg"
          alt="シルバー"
          className={styles.medal}
        />
      );
    case "gold":
    default:
      return (
        <img
          src="/images/user_frontend/global/icon/icn_awards_gold.svg"
          alt="ゴールド"
          className={styles.medal}
        />
      );
  }
};

export const RankingLabel: FC<Props> = ({ rank, children, className }) => {
  return (
    <span className={`${styles.label({ rank })} ${className ?? ""}`}>
      <RankingIcon rank={rank} />
      {children}
    </span>
  );
};
